import { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { ToastProvider } from '@koyomi/ui';
import './i18n.ts';
import { router } from './router.tsx';
import { useAuthStore } from './auth-store.ts';
import { refreshSession } from '../lib/api.ts';
import { ConflictProvider } from '../features/calendar/ConflictDialog.tsx';

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, staleTime: 15_000, refetchOnWindowFocus: false } } });

// Logout (por qualquer caminho: botão, 401 sem refresh) ou troca de negócio: nada do cache anterior pode sobrar.
useAuthStore.subscribe((state, prev) => {
  const loggedOut = prev.status === 'authenticated' && state.status === 'anonymous';
  const switched = prev.businessId !== null && state.businessId !== prev.businessId;
  if (loggedOut || switched) queryClient.clear();
});

export function App() {
  const status = useAuthStore((s) => s.status);
  useEffect(() => {
    if (status !== 'booting') return;
    void refreshSession().then((ok) => { if (!ok) useAuthStore.getState().setAnonymous(); });
  }, [status]);
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <ConflictProvider>
          <RouterProvider router={router} />
        </ConflictProvider>
      </ToastProvider>
    </QueryClientProvider>
  );
}
